import { render, staticRenderFns } from "./thingClass.vue?vue&type=template&id=bd156e24&"
import script from "./thingClass.vue?vue&type=script&lang=js&"
export * from "./thingClass.vue?vue&type=script&lang=js&"
import style0 from "./thingClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports